<template>
  <v-row justify="center">
    <v-col lg="4">
      <v-dialog
        v-model="dialogVisible"
        width="50%"
      >
        <v-card>
          <v-card-title class="indigo--text text--darken-1">
            Введите сумму зачисления
          </v-card-title>
          <v-card-subtitle
            class="indigo--text text--lighten-3"
          >
            Счёт -
            {{ account.AccountEmission ? account.AccountEmission.Account : "" }}
          </v-card-subtitle>
          <v-divider />
          <v-card-text>
            <v-text-field
              v-model="emissionAmount"
              label="Сумма зачисления"
              type="number"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-center">
            <v-btn
              color="primary"
              outlined
              @click="closeDialog"
            >
              Закрыть
            </v-btn>
            <v-btn
              color="primary"
              @click.stop="changeEmissionAmount(account)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import WebApi from "../../shared/modules/web_api"
import { AccountService } from "@/views/loyalty/shared/services/account-service"

export default {
  name: "AccountCustomerDialog",
  props: ["account", "dialogVisible"],
  data: () => ({
      accountService: null,
    emissionAmount: 0,
    dialog: false,
    webApi: null
  }),
  // beforeMount() {
  //   console.log(`AccountCustomerDialog ${this.account}`);
  // },
  mounted () {
      this.accountService = new AccountService()
    this.webApi = new WebApi(this.$store)
        .editSuccess("Сумма сохранена успешно!")
        .editError("Ошибка при сохранении суммы")
  },
  methods: {
    async changeEmissionAmount (acc) {
      const item = JSON.parse(JSON.stringify(acc))
      item.AccountEmission.Amount = this.emissionAmount
        console.log('item', item)
        await this.accountService.updateAmount(item.AccountEmission)

        acc.AccountEmission.Amount =
            +acc.AccountEmission.Amount + +this.emissionAmount
        this.closeDialog()
    },
    closeDialog () {
      this.$emit("close")
    }
  }
}
</script>

<style scoped></style>
